import { render, staticRenderFns } from "./AbkCompetencesBox.vue?vue&type=template&id=6035dbb9&scoped=true&"
import script from "./AbkCompetencesBox.vue?vue&type=script&lang=js&"
export * from "./AbkCompetencesBox.vue?vue&type=script&lang=js&"
import style0 from "./AbkCompetencesBox.vue?vue&type=style&index=0&id=6035dbb9&scoped=true&lang=scss&"
import style1 from "./AbkCompetencesBox.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6035dbb9",
  null
  
)

export default component.exports